var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.046,
    height: 10.956,
    viewBox: "0 0 17.046 10.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488395",
    "data-name": "Group 488395",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180755",
    "data-name": "Path 180755",
    d: "M104.93,168.166a8.374,8.374,0,0,1-4.6-1.524A15.412,15.412,0,0,1,96.6,163.17a.581.581,0,0,1-.052-.787,13.646,13.646,0,0,1,5.923-4.622,7.328,7.328,0,0,1,6.47.713,15,15,0,0,1,4.285,3.784c.316.4.318.568-.007.97a13.32,13.32,0,0,1-5.95,4.523,19.4,19.4,0,0,1-2.321.51Zm.3-1.107a11.781,11.781,0,0,0,1.613-.348,12.032,12.032,0,0,0,5.2-3.833.346.346,0,0,0-.037-.324,14.2,14.2,0,0,0-3.476-3.013,6.358,6.358,0,0,0-6.476-.39,13.812,13.812,0,0,0-4.233,3.428c-.155.178-.038.273.064.39a14.952,14.952,0,0,0,2.849,2.584A7.911,7.911,0,0,0,105.227,167.06Z",
    transform: "translate(-96.415 -157.306)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180756",
    "data-name": "Path 180756",
    d: "M177,194.987a3.374,3.374,0,1,1,3.421-3.309A3.392,3.392,0,0,1,177,194.987Zm2.3-3.382a2.252,2.252,0,1,0-2.236,2.26A2.282,2.282,0,0,0,179.3,191.605Z",
    transform: "translate(-168.532 -186.178)",
    fill: "#8e92a4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickIcon);
export default __webpack_public_path__ + "static/media/quickIcon.fe0c9f15dbb7c5d29edb0ab8d7aea587.svg";
export { ForwardRef as ReactComponent };